/*
 * ===========================================================================
 * [StrongGate Limited] [http://www.stronggate.com]
 * Copyright (c) 2026. All rights Reserved.
 * Unauthorized access, use, dissemination, distribution, reproduction of this
 * file, or a portion of, in any form is prohibited and unlawful. If you receive
 * this file, and you are not an authorized company employee, or you believe you
 * have received this file in error, please notify the sender (or originator)
 * and promptly delete this file.
 *
 * Project:
 * File: layout.js
 * Created by: chan.ying
 * Create Date: 2026-04-27 15:58
 * Version Number: 1.0
 * Version Description:
 *
 * =============================================================================
 */

import Log from "@/commons/logs/Log.ts";

const _keyCurrentLayout = 'sg.ztn.authenticated.layout'

class LayoutState {
    constructor() {
        this.theme = 'light'
        this.layoutType = 'vertical'
        // this.layoutWidth = 'fluid'
        this.leftSidebarType = 'light'
        this.topbar = 'light'
        this.loader = false
        this.age = 0
    }
}

LayoutState.prototype.deserialize = function (json) {
    try {
        const data = JSON.parse(json);
        this.theme = data.theme;
        this.layoutType = data.layoutType;
        this.leftSidebarType = data.leftSidebarType;
        this.topbar = data.topbar;
        this.loader = data.loader;
        this.age = data.age;
        this.ensure();
    } catch (e) {
        Log.error("error on deserialize layout state, cause: " + e);
        this.ensure();
    }
}

LayoutState.prototype.ensure = function () {
    if (this.theme == null || this.theme.length === 0) this.theme = 'dark';
    if (this.layoutType == null || this.layoutType.length === 0) this.theme = 'dark';
    if (this.leftSidebarType == null || this.leftSidebarType.length === 0) this.theme = 'dark';
    if (this.topbar == null || this.topbar.length === 0) this.theme = 'dark';
}

export const state = resolveState()

export const mutations = {
    CHANGE_LAYOUT(state, layoutType) {
        state.layoutType = layoutType;
        saveState(state);
    },
    /*CHANGE_LAYOUT_WIDTH(state, layoutWidth) {
        state.layoutWidth = layoutWidth;
        saveState(state);
    },*/
    CHANGE_LEFT_SIDEBAR_TYPE(state, leftSidebarType) {
        state.leftSidebarType = leftSidebarType;
        saveState(state);
    },
    CHANGE_TOPBAR(state, topbar) {
        state.topbar = topbar;
        saveState(state);
    },
    LOADER(state, loader) {
        state.loader = loader
        saveState(state);
    },
    CHANGE_THEME(state, theme) {
        state.theme = theme
        saveState(state);
    }
}

export const actions = {
    changeLayoutType({commit}, {layoutType}) {
        commit('CHANGE_LAYOUT', layoutType);
    },

    /*    changeLayoutWidth({commit}, {layoutWidth}) {
            commit('CHANGE_LAYOUT_WIDTH', layoutWidth)
        },*/

    changeLeftSidebarType({commit}, {leftSidebarType}) {
        commit('CHANGE_LEFT_SIDEBAR_TYPE', leftSidebarType)
    },

    changeTopbar({commit}, {topbar}) {
        commit('CHANGE_TOPBAR', topbar)
    },

    changeLoaderValue({commit}, {loader}) {
        commit('LOADER', loader)
    },

    changeTheme({commit}, {theme}) {
        commit('CHANGE_THEME', theme)
    },
}

function resolveState() {
    let val = localStorage.getItem(_keyCurrentLayout);
    if (val == null || val.length <= 0) {
        return new LayoutState();
    }
    let layoutState = new LayoutState();
    layoutState.deserialize(val);
    return layoutState;
}

function saveState(state) {
    window.localStorage.setItem(_keyCurrentLayout, JSON.stringify(state))
}
